import { Component }                           from '@angular/core';
import { FormBuilder }                         from '@angular/forms';
import { ActivatedRoute }                      from '@angular/router';
import { UntilDestroy }                        from '@ngneat/until-destroy';
import { LetDirective }                        from '@ngrx/component';
import { Store }                               from '@ngrx/store';
import { HistoryStats }                        from '@shared/classes/historyStats';
import { BreadcrumbEnum }                      from '@shared/enums/breadcrumb.enum';
import { SelectionEnum }                       from '@shared/enums/selection.enum';
import { ViewCaseEnum }                        from '@shared/enums/viewCase.enum';
import { DynamicComponent }                    from 'src/app/components/shared/dynamic/dynamicComponent/dynamic.component';
import { DYNAMIC_COMPONENTS }                  from 'src/app/components/shared/dynamic/dynamicComponent/dynamicComponent.constants';
import { selectCurrentViewById }               from 'src/app/shared/ngrx/store/actions/bilan.actions';
import { createHistory }                       from 'src/app/shared/ngrx/store/actions/history.actions';
import { selectCurrentView, selectTilesViews } from 'src/app/shared/ngrx/store/selectors/bilan.selector';
import { IBilanState }                         from 'src/app/shared/ngrx/store/state/bilan.state';
import { TrackingService }                     from 'src/app/shared/services/trackingService/tracking.service';
import { LocalStorageUtil }                    from 'src/app/shared/utils/localStorageUtil';
import { HeaderStepComponent }                 from '../../../shared/header-step/header-step.component';
import { Tile }                                from '../../../shared/tile/tile';
import { TileComponent }                       from '../../../shared/tile/tile.component';
import { AbstractStep }                        from '../abstract-step';

@UntilDestroy ()
@Component ({
              selector:    'app-step-two',
              templateUrl: './step-two.component.html',
              styleUrls:   ['./step-two.component.scss'],
              standalone:  true,
              imports:     [
                HeaderStepComponent,
                TileComponent,
                DynamicComponent,
                LetDirective,
              ],
              providers:   [],
            })
export class StepTwoComponent extends AbstractStep {
  public selectTilesViews$   = this._store.select (selectTilesViews);
  public selectCurrentView$  = this._store.select (selectCurrentView);
  public readonly components = DYNAMIC_COMPONENTS;

  constructor (
    override _fb: FormBuilder,
    protected _store: Store<IBilanState>,
    private trackingService: TrackingService,
    override route: ActivatedRoute,
  ) {
    super (_fb, route);
  }

  selectTile (tile: Tile) {
    console.log (tile);
    this.trackingService.trackButtonTilesClick (tile.id as ViewCaseEnum);
    this._store.dispatch (selectCurrentViewById ({ id: tile.id }));

    const history = new HistoryStats (LocalStorageUtil.getUserId (), BreadcrumbEnum.GAME, this.queryParams.PROFIL, SelectionEnum.TILE);
    history.infos = tile.id;
    this._store.dispatch (createHistory ({ historyStats: history }));
  }

  onChange (event: string) {
    const history          = new HistoryStats (LocalStorageUtil.getUserId (), BreadcrumbEnum.GAME, this.queryParams.PROFIL, SelectionEnum.SCREEN);
    history.selection_type = SelectionEnum.GAME;
    history.infos          = event;
    this._store.dispatch (createHistory ({ historyStats: history }));
  }
}
